import { Component, OnInit, ViewChild } from '@angular/core';
import {
  Enums,
  FavoritesList,
  HuntPackageRecord,
  ThreatProfile,
} from '@cyborg-monorepo/hunter/common';
import { PageChangeEvent } from '@progress/kendo-angular-pager';
import { HuntPackageComponent } from '../../../shared/components/hunt-package/hunt-package.component';
import { ThreatProfileComponent } from '../../../shared/components/threat-profiles/threat-profiles.component';
import { FavoriteService } from '../../../shared/services/favorite.service';
import { HuntPackageService } from '../../../shared/services/hunt-package.service';
import { ThreatProfileService } from '../../../shared/services/threat-profile.service';
import { UserService } from '../../../shared/services/user.service';

@Component({ standalone: false, 
  templateUrl: './favorites.component.html',
  styleUrls: ['./favorites.component.scss'],
})
export class MyFavoritesComponent implements OnInit {
  @ViewChild(HuntPackageComponent) public huntPackage: HuntPackageComponent;
  @ViewChild(ThreatProfileComponent)
  public threatProfile: ThreatProfileComponent;

  public huntPackages: Array<HuntPackageRecord> = [];
  public threatProfiles: Array<ThreatProfile> = [];
  public pageSize = 10;
  public skip = 0;
  public totalItems = 0;

  constructor(
    private favoriteService: FavoriteService,
    private huntPackageService: HuntPackageService,
    private threatProfileService: ThreatProfileService,
    private userService: UserService
  ) {}

  public ngOnInit(): void {
    this.getFavorites(10, 1);
    this.favoriteService.hasUpdated.subscribe(() => {
      this.getFavorites(10, 1);
    });
  }

  private getFavorites(size: number, page: number): void {
    this.userService
      .getFavorites(size, page)
      .subscribe((favorites: FavoritesList) => {
        this.huntPackages = [];
        this.threatProfiles = [];
        this.totalItems = favorites.meta.totalItems;

        for (const favorite of favorites.items) {
          if (favorite.index === Enums.CyborgIndexEnum.CYBORG_USE_CASES) {
            this.huntPackageService
              .getHuntPackageByUUID(favorite.targetUuid)
              .subscribe((results: HuntPackageRecord) => {
                this.huntPackages.push(results);
              });
          }
          if (favorite.index === Enums.CyborgIndexEnum.CYBORG_THREAT_PROFILES) {
            this.threatProfileService
              .getThreatProfileByUUID(favorite.targetUuid)
              .subscribe((results: ThreatProfile) => {
                this.threatProfiles.push(results);
              });
          }
        }
      });
  }

  public onPageChange(e: PageChangeEvent): void {
    this.skip = e.skip;
    this.getFavorites(this.pageSize, this.skip / this.pageSize + 1);
  }
}
